<div class="relative">

    <app-benefits-button/>

    <app-benefits-container/>

</div>